import { FunctionComponent } from 'react';
import styles from './MedicationComponent.module.scss';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import MedicationMethod from './UI/MedicationMethod/MedicationMethod';
import MedicalSchedule from './UI/MedicalSchedule/MedicalSchedule';
import MedicationDosage from './UI/MedicationDosage';
import clsx from 'clsx';
import { Medication } from 'model/NewMultipleBooking';
import { Moment } from 'moment-timezone';

interface Props {
    medicationState: Medication;
    setMedicationState: React.Dispatch<React.SetStateAction<Medication>>;
    index: number;
    from?: Moment | undefined;
    to?: Moment | undefined;
    flow: 'boarding' | 'daycare';
    medicationType: 'specific' | 'daily';
    onSetMedicationType: (index: number, type: string) => void;
    onHasAlerts?: (hasAlerts: boolean) => void;
}

export const MedicationComponent: FunctionComponent<Props> = ({
    medicationState,
    setMedicationState,
    index,
    from,
    to,
    flow,
    medicationType,
    onSetMedicationType,
    onHasAlerts
}) => {
    return (
        <div className={styles.cardContent}>
            <div className={styles.formSection}>
                <Input
                    label="Medication Name"
                    className={styles.input}
                    placeholder="Medication Name"
                    value={medicationState.name}
                    required={true}
                    onChange={e => setMedicationState(prev => ({ ...prev, name: e.target.value }))}
                />
            </div>
            <div className={clsx(styles.formSection, styles.methodSection)}>
                <div className={styles.sectionLeft}>
                    <MedicationMethod
                        selectedOption={medicationState.methodType}
                        onSelect={(methodType: number) =>
                            setMedicationState(prev => ({ ...prev, methodType: methodType }))
                        }
                    />
                </div>
                <div className={styles.sectionRight}>
                    <MedicationDosage
                        selectedQuantity={medicationState.dosage.quantity}
                        selectedUnit={medicationState.dosage.unit}
                        onQuantityChange={(quantity: number, unit: number) =>
                            setMedicationState(prev => ({
                                ...prev,
                                dosage: { ...prev.dosage, quantity: quantity, unit: unit }
                            }))
                        }
                    />
                </div>
            </div>
            <div className={styles.formSection}>
                <Input
                    label="Medication Instructions"
                    className={styles.instructions}
                    value={medicationState.instructions || ''}
                    onChange={e => setMedicationState(prev => ({ ...prev, instructions: e.target.value }))}
                    placeholder="Ex. Take with meal"
                />
            </div>
            <div className={styles.formSection}>
                <MedicalSchedule
                    schedule={medicationState.schedule || []}
                    specificSchedule={medicationState.specificSchedule || []}
                    medicationType={medicationType}
                    from={from}
                    to={to}
                    flow={flow}
                    onUpdate={schedule => setMedicationState(prev => ({ ...prev, schedule }))}
                    onUpdateSpecific={specificSchedule => setMedicationState(prev => ({ ...prev, specificSchedule }))}
                    onSetMedicationType={type => onSetMedicationType(index, type)}
                    onHasAlerts={onHasAlerts}
                />
            </div>
        </div>
    );
};

export default MedicationComponent;
